import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgContactKlantenservice = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <mask
      id="Contact_klantenservice_svg__a"
      width={26}
      height={26}
      x={7}
      y={7}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M20 33c7.18 0 13-5.82 13-13S27.18 7 20 7 7 12.82 7 20s5.82 13 13 13"
      />
    </mask>
    <g mask="url(#Contact_klantenservice_svg__a)">
      <path
        fill="#55468D"
        d="m-4.49 5.86 12.24 7.07L14.82.68zM7.75 12.93.68 25.18 20 20zM5.86 44.49l7.07-12.24L.68 25.18zM25.18 39.32l7.07-12.25L20 20zM20 20l-7.07 12.25 12.25 7.07zM39.32 14.82l-7.07 12.25 12.24 7.07zM34.14-4.49 14.82.68l12.25 7.07z"
      />
      <path
        fill="#31287C"
        d="M39.32 14.82 27.07 7.75 20 20z"
      />
      <path
        fill="#55468D"
        d="M-4.49 5.86.68 25.18l7.07-12.25zM5.86 44.49l19.32-5.17-12.25-7.07zM.68 25.18l12.25 7.07L20 20z"
      />
      <path
        fill="#31287C"
        d="m20 20 12.25 7.07 7.07-12.25z"
      />
      <path
        fill="#55468D"
        d="m44.49 34.14-12.24-7.07-7.07 12.25zM20 20l7.07-12.25L14.82.68zM14.82.68 7.75 12.93 20 20zM34.14-4.49 27.07 7.75l12.25 7.07z"
      />
    </g>
    <path
      fill="#fff"
      d="M18.45 17.56h3.1V28h-3.1zm1.55-1.6c-.57 0-1.04-.19-1.42-.57s-.58-.85-.58-1.41.19-1.03.58-1.41c.38-.38.86-.57 1.42-.57s1.04.19 1.42.57.58.85.58 1.41-.19 1.03-.58 1.41-.86.57-1.42.57"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgContactKlantenservice);

export default ForwardRef;
